import type { PortalHeroCopy } from './types';

interface Props {
  hero: PortalHeroCopy;
}

export function Hero({ hero }: Props) {
  return (
    <section className="hero">
      <div className="hero-eyebrow">{hero.eyebrow}</div>
      {hero.titleHtml ? (
        <h1 className="hero-title" dangerouslySetInnerHTML={{ __html: hero.titleHtml }} />
      ) : (
        <h1 className="hero-title">{hero.title}</h1>
      )}
      <p className="hero-subtitle">{hero.subtitle}</p>
    </section>
  );
}
